import { render, staticRenderFns } from "./PDFN.vue?vue&type=template&id=ff11aa52&scoped=true&"
import script from "./PDFN.vue?vue&type=script&lang=js&"
export * from "./PDFN.vue?vue&type=script&lang=js&"
import style0 from "./PDFN.vue?vue&type=style&index=0&id=ff11aa52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff11aa52",
  null
  
)

export default component.exports